import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";

import { Alert } from "../../../../../../../../../../mads";
import { Hide } from "../../../../../../../../../../mads/icons";
import { useI18n } from "../../../../../../../../../../shared/I18n";

export const EmployersPayInfoAlert = () => {
  const gt = useI18n();

  return (
    <Alert
      icon={<Hide color={colors.foregroundStatusInfo} aria-hidden />}
      status="info"
      explainerText={gt.gettext("Not shown to employers.")}
    />
  );
};
